<template>
  <div style="width: 100%; height: 100%; background-color: #eee">
    <l-map
      ref="map2"
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      attribution="© Проект А"
      style="z-index: 0"
    >
      <l-tile-layer :url="url" :attribution="attribution" />
      <!-- <v-geo-json v-for="(gj, idx) in geojson" :geojson="gj.geometry" :key="idx" :options="options(gj)">
        <v-popup :content="gotoTunnelCard" :options="{ autoClose: false, closeOnClick: false }"></v-popup>
      </v-geo-json> -->
    </l-map>
  </div>
</template>

<script>
import axios from "axios";
import _ from "lodash";
import { LMap, LTileLayer } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet-draw";
import { L, latLng, icon } from "leaflet";
import "@geoman-io/leaflet-geoman-free";
import "@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css";

export default {
  name: "DrawGeofenceOnMap",
  components: {
    LMap,
    LTileLayer,
  },
  data() {
    return {
      zoom: 13,
      maxZoom: 22,
      center: latLng(22.573768, 88.381173),
      //  url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      // url: "http://www.google.cn/maps/vt?lyrs=y@189&gl=cn&x={x}&y={y}&z={z}",
      //  url: "https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png",
      // attribution: 'google',
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      mapOptions: {
        zoomSnap: 1,
        minZoom: 10,
        maxBounds: [
          [29.033972, 70.192046],
          [6.3301302, 91.070748],
          // [21.448266, 89.071288]
        ],
      },
      windowHeight: window.innerHeight,
      psr10Icon: window.L.icon({
        iconUrl: require("../assets/10.png"),
        iconSize: [64, 64],
        iconAnchor: [32, 64],
        popupAnchor: [4, -25],
      }),
      psr15Icon: window.L.icon({
        iconUrl: require("../assets/15.png"),
        iconSize: [64, 64],
        iconAnchor: [32, 64],
        popupAnchor: [4, -25],
      }),
      psr20Icon: window.L.icon({
        iconUrl: require("../assets/20.png"),
        iconSize: [64, 64],
        iconAnchor: [32, 64],
        popupAnchor: [4, -25],
      }),
      psr30Icon: window.L.icon({
        iconUrl: require("../assets/30.png"),
        iconSize: [64, 64],
        iconAnchor: [32, 64],
        popupAnchor: [4, -25],
      }),
      psr45Icon: window.L.icon({
        iconUrl: require("../assets/45.png"),
        iconSize: [64, 64],
        iconAnchor: [32, 64],
        popupAnchor: [4, -25],
      }),
      psr50Icon: window.L.icon({
        iconUrl: require("../assets/50.png"),
        iconSize: [64, 64],
        iconAnchor: [32, 64],
        popupAnchor: [4, -25],
      }),
      psr65Icon: window.L.icon({
        iconUrl: require("../assets/65.png"),
        iconSize: [64, 64],
        iconAnchor: [32, 64],
        popupAnchor: [4, -25],
      }),
      psr75Icon: window.L.icon({
        iconUrl: require("../assets/75.png"),
        iconSize: [64, 64],
        iconAnchor: [32, 64],
        popupAnchor: [4, -25],
      }),
      nsOpenIcon: window.L.icon({
        iconUrl: require("../assets/ns_open.jpg"),
        iconSize: [40, 80],
        iconAnchor: [20, 80],
        popupAnchor: [4, -25],
      }),
    };
  },
  mounted() {
    const map = this.$refs.map2.mapObject;
    
    window.addEventListener("resize", () => {
      this.windowHeight = window.innerHeight;
    });

        var railway = window.L.tileLayer(
      "http://{s}.tile.openrailwaymap.org/{z}/{x}/{y}.png",
      {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }
    );
    var googleSateliteMap = window.L.tileLayer(
      "http://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}",
      {
        attribution: "google",
      }
    );
    var googleRoadMap = window.L.tileLayer(
      "http://www.google.cn/maps/vt?lyrs=m@189&gl=cn&x={x}&y={y}&z={z}",
      {
        attribution: "google",
      }
    );
    var googleHybrid = window.L.tileLayer(
      "http://www.google.cn/maps/vt?lyrs=h@189&gl=cn&x={x}&y={y}&z={z}",
      {
        attribution: "google",
      }
    );

    var baseLayers = {
      "Google Satelite": googleSateliteMap,
      "Google Road": googleRoadMap,
      "Google hybrid": googleHybrid,
      "Open Railway": railway,
    };
    var overlayMaps = {};
    window.L.control.layers(baseLayers, overlayMaps, { position: "bottomleft" }).addTo(map);

    this.zoom = localStorage.getItem("zoom_s_gf")
      ? parseInt(localStorage.getItem("zoom_s_gf"))
      : 11;

    this.center = localStorage.getItem("center_lat_s_gf")
      ? latLng(
          localStorage.getItem("center_lat_s_gf"),
          localStorage.getItem("center_lng_s_gf")
        )
      : latLng(22.573768, 88.381173);
    map.on("zoomend", () => {
      var zoomLevel = map.getZoom();
      localStorage.setItem("zoom_s_gf", map.getZoom());
      // var tooltip = $(".leaflet-tooltip");
      // var w = this.round(zoomLevel * 1.1, 0);
      // var h = this.round(zoomLevel * 1.8, 0);
      // var f = this.round(zoomLevel * 0.58, 0);
      // this.createSigIcon(w, h);
      // this.animateSig();
      // //tooltip.css('font-size', f);
      // console.log(zoomLevel);
    });

    map.on("moveend", () => {
      localStorage.setItem("center_lat_s_gf", map.getCenter().lat);
      localStorage.setItem("center_lng_s_gf", map.getCenter().lng);
      console.log(
        "moveend",
        localStorage.getItem("zoom_s_gf"),
        localStorage.getItem("center_lat_s_gf"),
        localStorage.getItem("center_lng_s_gf")
      );
    });
    const drawnItems = new window.L.FeatureGroup();
    axios.defaults.headers.common["Authorization"] = localStorage.getItem(
      "jwtToken"
    );
    axios
      .get(`${process.env.VUE_APP_API_URL}/geofences/`)
      .then((responses) => {
        //      console.log(responses.data);
        _.forEach(responses.data, function(o) {
          var geometry = JSON.parse(o.area);
          geometry.properties.id = o.id;
          var json = new window.L.GeoJSON(geometry, {
            pointToLayer: function(feature, latlng) {
              switch (feature.geometry.type) {
                case "Polygon":
                  //var ii = new L.Polygon(latlng)
                  //ii.addTo(drawnItems);
                  return window.L.polygon(latlng);
                case "LineString":
                  return window.L.polyline(latlng);
                case "Point":
                  return window.L.marker(latlng);
                default:
                  return;
              }
            },
            onEachFeature: function(feature, layer) {
              layer
                .bindTooltip(feature.properties.title, {
                  permanent: true,
                  direction: "center",
                  opacity: 0.8,
                  offset: [-50, 0],
                })
                .openTooltip();
              layer.addTo(drawnItems);
            },
          });
          //          console.log(json)
        });
      })
      .catch((e) => {
        console.log(e);
      });

    // var markersCautionLayer = new window.L.LayerGroup();
    // axios
    //   .get(`${process.env.VUE_APP_API_URL}/cautions`)
    //   .then((response) => {
    //     //console.log(response.data)
    //     var that = this;
    //     var tooltipPopup;
    //     for (var i = 0; i < response.data.length; i++) {
    //       var d = response.data[i];
    //       if (d.lat) {
    //         var ic = that.psr10Icon;
    //         switch (d.name) {
    //           case "10":
    //             ic = that.psr10Icon;
    //             break;
    //           case "15":
    //             ic = that.psr15Icon;
    //             break;
    //           case "20":
    //             ic = that.psr20Icon;
    //             break;
    //           case "30":
    //             ic = that.psr30Icon;
    //             break;
    //           case "45":
    //             ic = that.psr45Icon;
    //             break;
    //           case "50":
    //             ic = that.psr50Icon;
    //             break;
    //           case "65":
    //             ic = that.psr65Icon;
    //             break;
    //           case "75":
    //             ic = that.psr75Icon;
    //             break;
    //           case "ns_open":
    //             ic = that.nsOpenIcon;
    //             break;
    //           default:
    //             ic = that.psr20Icon;
    //         }
    //         var m = window.L.marker([d.lat, d.lng], {
    //           draggable: true,
    //           title: d.name,
    //           riseOnHover: true,
    //         })
    //           .setIcon(ic)
    //           .bindPopup(d.lat + ", " + d.lng, {
    //             className: "labelstyle",
    //             permanent: true,
    //             opacity: 1.0,
    //             direction: "center",
    //           })
    //           .addTo(markersCautionLayer)
    //           .addTo(map);
    //         // console.log(d);
    //         m.on("dragend", (e) => {
    //           // console.log(d);
    //           const data = {
    //             id: d.id,
    //             lat: e.target._latlng.lat,
    //             lng: e.target._latlng.lng,
    //           };
    //           axios
    //             .put(`${process.env.VUE_APP_API_URL}/cautions/`, data)
    //             .then((response) => {
    //               console.log(response);
    //             })
    //             .catch((e) => {
    //               console.log(e);
    //             });
    //         });
    //       }
    //     }
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //   });

    //      this.$nextTick(() => {
   

    const editableLayers = drawnItems.addTo(map);
    const drawControl = new window.L.Control.Draw({
      position: "topright",
      draw: {
        polyline: true,
        rectangle: false,
        circle: false,
        circlemarker: false,
        polygon: true,
        marker: false,
      },
      edit: {
        featureGroup: drawnItems,
        remove: false, // true -- to make visible delete button
      },
    });

    map.addControl(drawControl);

    map.on(window.L.Draw.Event.CREATED, (e) => {
      var stncode = window.prompt("Please enter station code");
      if (stncode != null && stncode.length > 0) {
        const layer = e.layer;
        const type = e.layerType;
        var feature = (layer.feature = layer.feature || {}); // Intialize layer.feature

        feature.type = feature.type || "Feature"; // Intialize feature.type
        var props = (feature.properties = feature.properties || {}); // Intialize feature.properties
        props.title = stncode;
        props.content = "Station";
        if (type === "marker") {
          // Do marker specific actions
        }
        // Do whatever else you need to. (save to db; add to map etc)
        const shape = layer.toGeoJSON();
        const shape_for_db = JSON.stringify(shape);

        const data = {
          name: stncode,
          description: "Station",
          area: shape_for_db,
        };

        axios
          .post(`${process.env.VUE_APP_API_URL}/geofences/`, data)
          .then((response) => {
            props.id = response.data.insertId;
            console.log(shape);
          })
          .catch((e) => {
            console.log(e);
          });
        editableLayers.addLayer(layer);
      }
    });
    map.on(window.L.Draw.Event.EDITED, (e) => {
      var layers = e.layers;
      layers.eachLayer(function(layer) {
        var feature = (layer.feature = layer.feature || {}); // Intialize layer.feature

        feature.type = feature.type || "Feature"; // Intialize feature.type
        var props = (feature.properties = feature.properties || {}); // Intialize feature.properties
        var geo = (feature.geometry = feature.geometry || {}); // Intialize feature.properties
        var stncode = window.prompt("Please enter station code", props.title);
        if (stncode != null && stncode.length > 0) {
          props.title = stncode;
          props.content = "Station";
          if (geo.type === "marker") {
            // Do marker specific actions
          }
          // Do whatever else you need to. (save to db; add to map etc)
          const shape = layer.toGeoJSON();
          const shape_for_db = JSON.stringify(shape);

          const data = {
            id: props.id,
            name: stncode,
            description: "Station",
            area: shape_for_db,
          };
          axios
            .put(`${process.env.VUE_APP_API_URL}/geofences/`, data)
            .then((response) => {
              console.log(response);
            })
            .catch((e) => {
              console.log(e);
            });
        }
        //do whatever you want; most likely save back to db
      });
    });

    map.on(window.L.Draw.Event.DELETED, (e) => {
      var layers = e.layers;
      layers.eachLayer(function(layer) {
        var feature = (layer.feature = layer.feature || {}); // Intialize layer.feature

        feature.type = feature.type || "Feature"; // Intialize feature.type
        var props = (feature.properties = feature.properties || {}); // Intialize feature.properties
        const data = {
          id: props.id,
        };
        axios
          .delete(`${process.env.VUE_APP_API_URL}/geofences/`, { params: data })
          .then((response) => {
            console.log(response);
          })
          .catch((e) => {
            console.log(e);
          });

        //do whatever you want; most likely save back to db
      });
    });
    //      });
  },
  methods: {},
};
</script>
